import { z } from "zod";

/** `YYYY-MM-DD`, as stored in date filter search params. */
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** Optional, and a bad value is dropped instead of failing the page (route search params). */
export function lenient<T extends z.ZodType>(schema: T) {
  // zod needs the explicit fallback value here.
  // eslint-disable-next-line unicorn/no-useless-undefined
  return schema.optional().catch(undefined);
}
